import React from 'react';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { withRenderFlag } from '@beef/react';
import classNames from 'classnames/bind';

import { EnrichedAccumItemType } from 'types/accumulators';
import { UNIT_LOCALE } from 'constants/accumulators';
import {
  formatTimeUnit,
  getMainTextVariant,
  getSecondaryTextVariant,
  getTextColorForGiftedAccumulator,
} from 'utils/accumulators';
import { useIsMobileDimension } from 'hooks';
import { TWithShouldRenderProp } from 'types';

import { BaseTextContent } from '../BaseTextContent';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

interface IProps {
  accumulator: EnrichedAccumItemType;
  isInline?: boolean;
  isMobile?: boolean;
}

const GIFT_ADDITIONAL_FULL = 'доп пакет';
const GIFT_ADDITIONAL_NOT_FULL = 'из 1 тб доп';

const _GiftedAccumulator: React.FC<IProps> = ({
  accumulator,
  isInline = false,
  isMobile = false,
}) => {
  const isMobileDimension = useIsMobileDimension();
  const { rest, displayUnit, size } = accumulator;
  const unit = formatTimeUnit(displayUnit?.toLowerCase() ?? '');

  const secondaryText =
    !size && rest === 1 && unit === UNIT_LOCALE.TERABYTE.toLowerCase() ?
      GIFT_ADDITIONAL_FULL
    : GIFT_ADDITIONAL_NOT_FULL;

  const textColor = getTextColorForGiftedAccumulator(rest);

  return (
    <div className={cn(cnComponentsTheme('light'), { inline: isInline })}>
      <BaseTextContent
        mainText={`${rest} ${unit}`}
        mainTextColor={textColor}
        mainTextVariant={getMainTextVariant(isInline, isMobile || isMobileDimension)}
        secondaryText={secondaryText}
        secondaryTextColor={textColor}
        secondaryTextVariant={getSecondaryTextVariant(isMobile || isMobileDimension)}
        shouldRender
      />
    </div>
  );
};

export const GiftedAccumulator: TWithShouldRenderProp<typeof _GiftedAccumulator> =
  withRenderFlag(_GiftedAccumulator);
